import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { useUpcomingTransactions } from "@hooks";
import { Translations, i18n } from "@i18n";

import { TransactionList } from "@routes/TransfersRoute/TransactionList";

export const UpcomingTransfers = () => {
  const { data, loading, error } = useUpcomingTransactions();

  if (loading) return null;

  if (error) {
    return (
      <>
        <Spacing size={SpacingSizes.M} />
        <Body>{i18n.t(Translations.GenericErrorMessage)}</Body>
      </>
    );
  }

  if (data.length === 0) {
    return (
      <>
        <Spacing size={SpacingSizes.M} />
        <Body>{i18n.t(Translations.TransfersRouteUpcomingNoTransfers)}</Body>
      </>
    );
  }

  return <TransactionList data={data} upcoming />;
};
